/** Redux page keys for Security filter persistence (session memory until logout or reset). */
export const SECURITY_PAGE_FILTER_KEYS = {
  vulnerabilityDetection: 'vulnerability-detection',
  malwareDetection: 'malware-detection',
  fileIntegrityMonitoring: 'file-integrity-monitoring',
  configurationAssessment: 'configuration-assessment',
  automatedResponse: 'automated-response',
  threatHunting: 'threat-hunting',
  mitreAttck: 'mitre-attck',
  endpoints: 'endpoints',
  socDashboard: 'soc-dashboard',
} as const;

export const SECURITY_DEFAULT_DATE_RANGE = '' as const;

/** First-visit defaults for Vulnerability Detection only. */
export const SECURITY_VULNERABILITY_FILTER_DEFAULTS: Record<string, string> = {
  status: 'open',
};
